/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from '../axios'
import axios110 from '../axios110'
import axios120 from '../axios120'
const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  updateUserRole({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch('updateUserInfo', { userRole: payload.userRole })
  },

  login({ commit, dispatch }, authData) {

    axios120.post('/ecommerce/web/auth/login', {
      email: authData.email,
      password: authData.password
    })
      .then(res => {
        console.log(res)
        if (res.status != 200) {
          commit('authError')
        }
        if (res.data.user.role == 4 && res.data.user.company == null) {
          commit('noCompanyError')
          return
        }
        commit('authUser', res.data)

        location.reload()
      })
      .catch(error => {
        commit('authError')
        console.log(error.response)
      })

  },
  tryAutoLogin({ commit, dispatch }) {
    const token = localStorage.getItem('token')
    if (!token) {
      return
    }
    const expired_at = localStorage.getItem('expired_at')
    const now = new Date()
    if (now >= expired_at) {
      return
    }
    const user = JSON.parse(localStorage.getItem('user'))

    axios120.post('/ecommerce/web/auth/profile', {})
      .then(res => {
        console.log(res)
        user = res.data

      })
      .catch(error => {

        console.log(error.response)
      })
    dispatch('getNotification')
    const dataUser = { token, user }
    commit('authUser', dataUser)
  },
  setLogoutTimer({ commit }) {
    setTimeout(() => {
      commit('clearAuthData')
    }, 3600)

  },
  logout({ commit }) {
    commit('clearAuthData')
  },
  updateCompany({ commit }, company) {
    commit('setCompany', company)
  },
  updateUser({ commit }, user) {
    console.log(user)
    commit('setUser', user)
  },
  getNotification({ commit }) {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user.role == 3) {
      axios110.get('/ecommerce/web/dashboard/transaction', {})
        .then(res => {
          commit('setTransaction', res.data)

        })
        .catch(error => {

          commit('setTransaction', 0)
        })
    }
    else (
      axios110.get('/ecommerce/web/dashboard/shipment/' + user.company.id, {})
        .then(res => {
          commit('setShipment', res.data)

        })
        .catch(error => {

          commit('setShipment', 0)
        })

    )

  },

}

export default actions
